import { Col, Form, InputNumber, Modal, Row } from 'antd';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';
import { Expense } from '../../modules/expenses';

const StyledDiv = styled.div``;

interface ChangeExpensePriceModalProps {
  visible: boolean;
  expense: Expense;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function ChangeExpensePriceModal({
  visible,
  expense,
  onCreate,
  onCancel,
}: ChangeExpensePriceModalProps) {
  const [form] = Form.useForm();

  const updatePriceField = () => {
    const price = form.getFieldValue('price');
    const supplyPrice = Math.round(price / 1.1);
    const vat = price - supplyPrice;
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  const updateSupplyPriceField = () => {
    const supplyPrice = form.getFieldValue('supplyPrice');
    const vat = Math.round(supplyPrice * 0.1);
    const price = supplyPrice + vat;
    console.log('supplyPrice', supplyPrice);
    console.log('vat', vat);
    console.log('price', price);
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  const updateVatField = () => {
    const price = form.getFieldValue('price');
    const vat = form.getFieldValue('vat');
    const supplyPrice = price - vat;
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="지출금액 수정"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              price: expense.price,
              supplyPrice: expense.price - expense.vat,
              vat: expense.vat,
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="price"
                  label="합계 금액(환불 시 마이너스 금액 입력)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                    onChange={updatePriceField}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  name="supplyPrice"
                  label="공급가액(환불 시 마이너스 금액 입력)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                    onChange={updateSupplyPriceField}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="vat"
                  label="부가세(환불 시 마이너스 금액 입력)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                    onChange={updateVatField}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col span={24}>
                <Form.Item
                  name="reason"
                  label="변경사유"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default ChangeExpensePriceModal;
